import React from "react";
import moment from "moment";
import FormGroup from "../../Form/FormGroup";
import Button from "../../Form/Button";
import Select from "../../Form/Select";
import Input from "../../Form/Input";
import Textarea from "../../Form/Textarea";
import FormGroupInline from "../../Form/FormGroupInline";
import DatePicker from "../../Form/DatePicker";
import TimePicker from "../../Form/TimePicker";
import Checkbox from "../../Form/Checkbox";
import styles from "./modalOutboundCampaign.module.css";

const whenSend = [
    { id: "NOW", value: "Enviar agora" },
    { id: "SCHEDULE", value: "Agendar o envio" },
]

const ConfigSend = ({ data, inboxes = [], handleChangeValue = () => { }, handleChangeStep = () => { } }) => {
    const onChangeStep = () => {
        handleChangeStep(2)
    }

    return (
        <>
            <FormGroup labelText="Nome">
                <Input placeholder="Nome da campanha" value={data?.name ?? ""} onChange={(e) => handleChangeValue("name", e.target.value)} />
            </FormGroup>
            <FormGroup labelText="Descrição">
                <Textarea placeholder="Descrição da campanha" value={data?.description ?? ""} onChange={(e) => handleChangeValue("description", e.target.value)} rows={3} />
            </FormGroup>
            <FormGroup labelText="Caixa de Entrada">
                <Select multiple={false} name="Caixa de Entrada" placeholder="Selecione uma caixa de entrada" options={inboxes || []} selected={data?.inbox_id ?? ""} onChange={(value) => handleChangeValue("inbox_id", value)} />
            </FormGroup>
            <FormGroup labelText="Quando enviar?">
                <Select multiple={false} name="Quando enviar?" placeholder="Selecione uma opção" options={whenSend || []} selected={data?.when_send ?? ""} onChange={(value) => handleChangeValue("when_send", value)} />
            </FormGroup>
            {data?.when_send === "SCHEDULE" &&
                <FormGroup labelText="Agendar envio para">
                    <FormGroupInline>
                        <DatePicker name="Data do envio" dateStart={data?.date_schedule_send} min={moment().startOf("day")} multiple={false} onChange={(value) => handleChangeValue("date_schedule_send", value)} />
                        <TimePicker name="Horário do envio" time={data?.time_schedule_send} onChange={(value) => handleChangeValue("time_schedule_send", value)} />
                    </FormGroupInline>
                </FormGroup>
            }
            <button type="button" className={styles.checkboxOption} onClick={() => handleChangeValue("update_conversations", data?.update_conversations === false)}>
                <Checkbox checked={data?.update_conversations !== false} pink={true} />
                <div className={styles.checkboxText}>
                    <strong>Mostrar o disparo na lista de conversas</strong>
                    <span>Quando ativo, cada mensagem enviada pela campanha aparece como última mensagem e pode mover a conversa para o topo. Desative para enviar a campanha sem reorganizar a lista de atendimento.</span>
                </div>
            </button>

            <FormGroup>
                <Button variant='primary' onClick={onChangeStep}>Avançar</Button>
            </FormGroup>
        </>
    )
}

export default ConfigSend
